/* @ngInject */
const dispatchButtons = (
  icons,
  dispatchGo,
  dispatchAsk
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: dispatchGo.consult,
    display: (_nature) => _nature === 'tables',
  }

  self.edit = {
    icon: icons.edit,
    action: dispatchGo.edit,
    display: () => true,
  }

  self.delete = {
    icon: icons.delete,
    action: dispatchAsk.delete,
    display: (_nature) => _nature === 'action',
    class: (_dispatch) => {
      return 'retour'
    },
  }

  return self
}
export default dispatchButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/resources/buttons.resource.js